// ManagedModal.tsx
import React, { useEffect, useState } from 'react';
import { useModalManager } from '../../context/ModalManagerContext';

interface ManagedModalProps {
  id: string;
  children: React.ReactElement;
  visible?: boolean;
}

export const ManagedModal: React.FC<ManagedModalProps> = ({ id, children, visible }) => {
  const { registerModal, unregisterModal, openModal, closeModal } = useModalManager();
  const [isVisible, setIsVisible] = useState(visible ?? false);

  useEffect(() => {
    // Register this modal with the manager
    registerModal(id, () => {
      setIsVisible(false);
    });
    
    return () => {
      unregisterModal(id);
    };
  }, [id]);

  useEffect(() => {
    if (visible !== undefined) {
      if (visible) {
        openModal(id);
        setIsVisible(true);
      } else {
        closeModal(id);
        setIsVisible(false);
      }
    }
  }, [visible, id]);

  // Update this key part - use isVisible, not children.props.visible
  if (!isVisible) {
    return null;
  }

  // Clone the child element and pass the visibility prop
  const childWithProps = React.cloneElement(children, {
    ...children.props,
    visible: true, // Always true here since we control rendering
    onClose: () => {
      setIsVisible(false);
      closeModal(id);
      if (children.props.onClose) {
        children.props.onClose();
      }
    },
  });

  return childWithProps;
};